
<div class="map-config-wrapper">
    <div class="map-config-second-layer">
        <div class="d-flex justify-content-between map-config-header">
            <div class="">
            <div class="main-title">
                Map Configuration
            </div>
            <div class="subtitle">
                Powering Connectivity, Empowering Operations
            </div>
            </div>
            <div class="d-flex action-buttons">
                <button class="btn btn-primary" (click)="saveMapConfiguration()">Save Changes</button>
                <button #closeMapConfigurationModal 
                        type="button" 
                        class="btn btn-danger" 
                        data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
        <div class="map-container">
            <google-map 
                #map
                height="100%"
                width="100%"
                [zoom]="zoom ? zoom : 4"
                [center]="{ lat: latitude ? latitude : 9.1021111, lng: longitude ? longitude : 18.2811944 }"
                [options]="{
                    mapTypeControl: true,
                    streetViewControl: false,
                    fullscreenControl: true
                    }"
                >
            </google-map>

        </div>
    </div>
</div>


